import { useTranslation } from 'react-i18next';
import { uploadImage } from '@/store/services/commonServices';
import { getFullname, getNameInitials } from '@/helpers/utils';
import ProfileAvatarForm from '@/components/Forms/ProfileAvatarForm';
import { cropAvatar } from '@/components/AvatarEdit';
import { useUpdateProfilePhoto } from '@/query/queries/user/useUpdateProfilePhoto';
import { useGetMe } from '@/hooks/shared/useGetMe';

const ProfileAvatarModal = ({ onClose }) => {
  const { user } = useGetMe()
  const { mutateAsync: updateProfilePhoto } = useUpdateProfilePhoto();
  const { t } = useTranslation('modal');

  const onSubmit = async (data, _, editorRef) => {
    try {
      if (data.file && editorRef) {
        const croppedAvatar = cropAvatar(editorRef);
        const response = await uploadImage(croppedAvatar);
        if (response && response.success) {
          const res = await updateProfilePhoto({ photo: response.data.id });
          res && onClose();
        }
      }
    } catch (e) {}
  };

  const onRemove = async () => {
    try {
      const res = await updateProfilePhoto({ photo: null });
      res?.image && onClose();
    } catch (e) {}
  };

  if (!user) {
    return (
      <div style={{ padding: '70px 50px' }}>{t('profile_avatar_modal.could_not_load_image')}</div>
    );
  }

  return (
    <ProfileAvatarForm
      photo={user.photo}
      fullname={getFullname(user.first_name, user.last_name)}
      nameInitials={getNameInitials(user.first_name, user.last_name)}
      onSubmit={onSubmit}
      onRemove={onRemove}
    />
  );
};

export default ProfileAvatarModal;
